import '.l{overflow:hidden;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.bm{height:4rem;}.ssr-plugin'
import cityOfUtrechtImage from '@app/assets/images/partners/city_of_utrecht.png'
import maakOosterworldImage from '@app/assets/images/partners/maak_oosterworld.png'
import provincieDrenthImage from '@app/assets/images/partners/provincie_drenthe.png'
import raboBankImage from '@app/assets/images/partners/rabobank.jpg'
import woonImage from '@app/assets/images/partners/woon.png'
import zwolleImage from '@app/assets/images/partners/zwolle.png'
import { Image } from '@app/components/core/image/Image'
import { ScrollingBanner } from '@app/components/core/scrollingBanner/ScrollingBanner'
import { styled } from 'inlines'

const partners = [
  {
    imageAlt: 'Gemeente Utrecht',
    imageSrc: cityOfUtrechtImage,
  },
  {
    imageAlt: 'Maak Oosterworld',
    imageSrc: maakOosterworldImage,
  },
  {
    imageAlt: 'Provincie Drenthe',
    imageSrc: provincieDrenthImage,
  },
  {
    imageAlt: 'Rabobank',
    imageSrc: raboBankImage,
  },
  {
    imageAlt: 'Woon',
    imageSrc: woonImage,
  },
  {
    imageAlt: 'Gemeente Zwolle',
    imageSrc: zwolleImage,
  },
]

export const OurPartners = () => {
  return (
    <div className="l a4 bm">
      <ScrollingBanner
        gap="4rem"
        style={{ position: 'absolute', left: 0, right: 0 }}
      >
        {partners.map((partner, index) => (
          <Image
            key={index}
            src={partner.imageSrc}
            alt={partner.imageAlt}
            resizeHeight={64}
            style={{
              height: '4rem',
              width: 'auto',
              maxWidth: '20rem',
              objectFit: 'contain',
            }}
          />
        ))}
      </ScrollingBanner>
    </div>
  )
}
